var toString = require('./toString');
module.exports = function isFunction(obj){
	return toString.call(obj) == '[object Function]';
};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isFunction.js
 ** module id = 15
 ** module chunks = 0
 **/